import React, { Component, PropTypes } from 'react';
import { buildQueryString } from 'utils/UrlUtils';

let didFlippCircularScriptLoad = false;

class FlippCircular extends Component {
  static propTypes = {
    partnerName: PropTypes.string,
    resizeMode: PropTypes.oneOf(['WINDOW', 'FIXED', 'HEADER', 'PAGE']),
    fixedIframeHeight: PropTypes.number,
    minHeight: PropTypes.number,
    initialHeight: PropTypes.number,
    extraPadding: PropTypes.number,
    queryParameters: PropTypes.shape({
      flyerIdentifier: PropTypes.string,
      flyerStackIdentifier: PropTypes.string,
      shareFlyerItemId: PropTypes.number,
      locale: PropTypes.string,
      postalCode: PropTypes.string,
      autoLocate: PropTypes.bool,
      utmCampaign: PropTypes.string,
      utmSource: PropTypes.string,
      utmMedium: PropTypes.string,
      utmTerm: PropTypes.string,
      utmContent: PropTypes.string
    })
  };

  static contextTypes = {
    config: PropTypes.object.isRequired
  }

  static defaultProps = {
    partnerName: '',
    resizeMode: 'WINDOW',
    fixedIframeHeight: 800,
    minHeight: 550,
    initialHeight: 1000,
    extraPadding: 70,
    queryParameters: {}
  }

  componentDidMount() {
    const {
      config: {
        affiliate: {
          name = ''
        } = {}
      } = {}
    } = this.context;

    const {
      partnerName = name,
      resizeMode,
      fixedIframeHeight,
      minHeight,
      initialHeight,
      extraPadding,
      queryParameters: {
        flyerIdentifier: flyer_identifier,
        flyerStackIdentifier: flyer_stack_identifier,
        shareFlyerItemId,
        locale,
        postalCode: postal_code,
        autoLocate: auto_locate,
        utmCampaign: utm_campaign,
        utmSource: utm_source,
        utmMedium: utm_medium,
        utmTerm: utm_term,
        utmContent: utm_content
      }
    } = this.props;

    const queryParameters = {
      flyer_identifier,
      flyer_stack_identifier,
      shareFlyerItemId,
      locale,
      postal_code,
      auto_locate,
      utm_campaign,
      utm_source,
      utm_medium,
      utm_term,
      utm_content
    };

    if (!didFlippCircularScriptLoad && partnerName && typeof window !== 'undefined' && typeof document !== 'undefined') {
      const queryString = buildQueryString(queryParameters);

      const flippConfig = {
        minHeight,
        initialHeight,
        extraPadding,
        queryParameters: queryString
      };
      const pageSizing = resizeMode === 'FIXED' ? fixedIframeHeight : resizeMode;
      const flippScript = document.createElement('script');

      flippScript.type = 'text/javascript';
      flippScript.src = `http://circulars.${partnerName}.com/distribution_services/iframe.js`;
      document.body.appendChild(flippScript);
      didFlippCircularScriptLoad = true;
      window.addEventListener('load', () => {
        this.createFlippCircularIframe(partnerName, pageSizing, flippConfig);
      });
    }
  }

  createFlippCircularIframe(partnerName, pageSizing, flippConfig) {
    const wishabi = window['wishabi'];

    if (typeof wishabi !== 'undefined') {
      wishabi.distributionservices.iframe.decorate(
        'circ-container',
        partnerName,
        isNaN(pageSizing) ? wishabi.distributionservices.iframe.Sizing[pageSizing] : pageSizing,
        flippConfig
      );
    }
  }

  render() {
    return (
      <div id="circ-container"></div>
    );
  }
}

export default FlippCircular;



// WEBPACK FOOTER //
// ./app/components/custom/heartland/thirdParty/FlippCircular.js